import type { QueryClient } from '@tanstack/vue-query';

import { queryKeys } from './queryKeys';

export function invalidateTeamMembers(queryClient: QueryClient, accountId: string) {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.team.members(accountId),
  });
}

export function invalidateAssignedProperties(
  queryClient: QueryClient,
  accountId: string,
  teamMemberId?: string,
) {
  if (teamMemberId) {
    return queryClient.invalidateQueries({
      queryKey: ['properties', 'assigned', accountId, teamMemberId],
    });
  }

  return queryClient.invalidateQueries({ queryKey: queryKeys.properties.all });
}

export function invalidateUnassignedProperties(
  queryClient: QueryClient,
  accountId: string,
  teamMemberId: string,
) {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.properties.unassigned(accountId, teamMemberId),
  });
}

export function invalidateClustersList(queryClient: QueryClient, accountId: string) {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.clusters.list(accountId),
  });
}

export function invalidateBrandsList(queryClient: QueryClient, accountId: string) {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.brands.list(accountId),
  });
}

export function invalidatePagesList(queryClient: QueryClient, accountId: string) {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.pages.list(accountId),
  });
}

export function invalidateAccountScopedQueries(
  queryClient: QueryClient,
  accountId: string,
) {
  return Promise.all([
    invalidateAssignedProperties(queryClient, accountId),
    invalidateTeamMembers(queryClient, accountId),
    invalidateClustersList(queryClient, accountId),
    invalidateBrandsList(queryClient, accountId),
    invalidatePagesList(queryClient, accountId),
    queryClient.invalidateQueries({
      queryKey: queryKeys.properties.account(accountId),
    }),
  ]);
}
